import type { PersistedTopics, TopicsPersistenceService } from '../../application'

import { BaseWebStorage } from './Base'
import { isCompressedPersistedTopics } from './Validators'

export type CompressedPersistedTopics = Readonly<{ allTopics: readonly string[], custom: readonly number[], selected: readonly number[] }>

export class WebStorageTopicsPersistenceService extends BaseWebStorage<PersistedTopics, CompressedPersistedTopics> implements TopicsPersistenceService {
    protected readonly fallbackValue = { custom: [], selected: [] }

    protected readonly key = 'explorerTopics'

    protected override readonly ignoreVersionMismatch = true

    // eslint-disable-next-line class-methods-use-this
    protected toSerializable ({ custom, selected }: PersistedTopics): CompressedPersistedTopics {
        const allTopics = Array.from(new Set([...custom, ...selected]))

        const compressed: CompressedPersistedTopics = {
            allTopics,
            custom: custom.map((t) => allTopics.indexOf(t)),
            selected: selected.map((t) => allTopics.indexOf(t)),
        }

        return compressed
    }

    // eslint-disable-next-line class-methods-use-this
    protected isValidSerializable (unknownValue: unknown): unknownValue is CompressedPersistedTopics {
        return (
            isCompressedPersistedTopics(unknownValue) &&
            ![unknownValue.custom, unknownValue.selected].some((arr) => arr.some((i) => unknownValue.allTopics[i] === undefined))
        )
    }

    // eslint-disable-next-line class-methods-use-this
    protected fromSerializable (compressed: CompressedPersistedTopics): PersistedTopics {
        const { allTopics, custom, selected } = compressed
        return { custom: custom.map((c) => allTopics[c]!), selected: selected.map((s) => allTopics[s]!) }
    }

    retrieveTopics (): PersistedTopics {
        return this.retrieveDeserialize()
    }

    persistTopics (topics: PersistedTopics): void {
        this.persistSerialize(topics)
    }
}
